import React, { memo, useCallback } from 'react';

import { NUM_COLUMNS } from 'components/list-card-group/styled';
import { ListCardGroupVariant } from 'components/list-card-group/types';
import { StaticCardGrid } from 'components/product-customization/static-layout';
import { Modifier } from 'components/product-detail-v2/modifier/modifier';
import { t } from 'state/intl/translations';

import { IModifierData } from '../modifier/types';

import { IModifierGroupProps } from './types';

interface ModifierGridItemProps {
  modifierProps: IModifierData;
  onModifierSelectionChange: IModifierGroupProps['onModifierSelectionChange'];
  selectedItem: IModifierGroupProps['selectedItem'];
}

const ModifierGridItem = memo(function ModifierGridItem({
  modifierProps,
  onModifierSelectionChange,
  selectedItem,
}: ModifierGridItemProps) {
  const handleSelectionsChange = useCallback(
    (selections: IModifierData['selections']) => {
      onModifierSelectionChange(selections, modifierProps.modifier);
    },
    [modifierProps.modifier, onModifierSelectionChange]
  );

  return (
    <Modifier
      key={`modifier-${modifierProps.modifier._key}`}
      modifier={modifierProps.modifier}
      selections={modifierProps.selections}
      onSelectionsChange={handleSelectionsChange}
      selectedItem={selectedItem}
    />
  );
});

export const ModifierGroup = memo(function ModifierGroup({
  displayGroupName,
  modifiers,
  onModifierSelectionChange,
  selectedItem,
  isFullContainer = false,
}: IModifierGroupProps) {
  return (
    <StaticCardGrid
      numColumns={NUM_COLUMNS}
      isFullContainer={isFullContainer}
      listCardGroupVariant={ListCardGroupVariant.GROUP}
      header={displayGroupName ? t(displayGroupName) : undefined}
      items={modifiers}
      renderItem={({ item: modifierProps }) => (
        <ModifierGridItem
          key={`modifier-${modifierProps.modifier._key}`}
          modifierProps={modifierProps}
          onModifierSelectionChange={onModifierSelectionChange}
          selectedItem={selectedItem}
        />
      )}
    />
  );
});
